import { render, staticRenderFns } from "./PropertyEditor.vue?vue&type=template&id=0076343d&scoped=true&"
import script from "./PropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyEditor.vue?vue&type=style&index=0&id=0076343d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076343d",
  null
  
)

export default component.exports